export default {
  imageCheck: '/v3/helmet/async/imageCheck'
}
